import { useMemo } from 'react'
import { Base, PlusIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import posthog from 'posthog-js'
import { useFilter } from '@/application/use-filter'
import { renderChecklistCount, useChecklistLabels } from '@/ui/shared/checklist'

interface FilterProps {
  name: string
  options: string[]
}

export const Filter: React.FC<FilterProps> = ({ name, options }) => {
  const { t } = useTranslation()
  const labels = useChecklistLabels(
    `${t('filter.search')} ${name.toLowerCase()}`
  )
  const { getFilterValues, updateFilterValues } = useFilter(name)
  const selected = getFilterValues()

  const checklist = useMemo(
    () => options.map((option) => ({ value: option, label: option })),
    [options]
  )

  const apply = (values: string[]) => {
    updateFilterValues(values)
    posthog?.capture('Filter Applied', { filter: name })
  }

  return (
    <Base.ChecklistPopover
      trigger={
        <>
          <PlusIcon />
          {formatFilterName(name)}
        </>
      }
      count={selected.length}
      renderCount={renderChecklistCount}
      title={`${t('filter.select')} ${name.toLowerCase()}`}
      options={checklist}
      selected={selected}
      onApply={apply}
      labels={labels}
    />
  )
}

const formatFilterName = (name: string) =>
  name.length < 2
    ? name
    : name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
